import { render, staticRenderFns } from "./SubstituteTeacher.vue?vue&type=template&id=54c76ee4&"
import script from "./SubstituteTeacher.vue?vue&type=script&lang=js&"
export * from "./SubstituteTeacher.vue?vue&type=script&lang=js&"
import style0 from "./SubstituteTeacher.vue?vue&type=style&index=0&id=54c76ee4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports